var _a;
import { ThemeVariant } from '@/utils/themes/types';
import dark from "./dark";
import light from "./light";
// Default app theme
var etcrm = {
    label: 'EtCRM',
    variants: (_a = {},
        _a[ThemeVariant.LIGHT] = {
            label: 'ETCRM (Light)',
            variables: light,
        },
        _a[ThemeVariant.DARK] = {
            label: 'ETCRM (Dark)',
            variables: dark,
        },
        _a),
    default: true,
};
// Default theme
var theme = {
    etcrm: etcrm,
};
export default theme;
